import { listQueryParameters } from './queries.generated';

export type ListQuery = Record<string, string | number | boolean | undefined>;

export function supportsListSearch(path: string) {
  const supported = listQueryParameters[path];
  return !supported?.length || supported.includes('search');
}

export function listQuery(path: string, query: ListQuery): ListQuery {
  const supported = listQueryParameters[path];
  return Object.fromEntries(
    Object.entries(query)
      .filter(
        ([key, value]) =>
          value !== undefined &&
          (!supported?.length ||
            supported.includes(key) ||
            (['pageSize', 'limit'].includes(key) &&
              supported.some((item) => ['pageSize', 'limit'].includes(item)))),
      )
      // Controllers share the cursor contract's limit parameter.
      .map(([key, value]) => [key === 'pageSize' ? 'limit' : key, value]),
  );
}
